import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 19 18.414"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", { d: "M8.368 16.13a1.072 1.072 0 1 0-.435 2.1 9.206 9.206 0 1 0-6.65-5.5.214.214 0 0 1-.072.257l-.857.622a.857.857 0 0 0 .323 1.521l3.383.728a.91.91 0 0 0 .18.019.857.857 0 0 0 .838-.677l.81-3.772a.857.857 0 0 0-1.342-.874l-1.167.848a.214.214 0 0 1-.331-.11 7.077 7.077 0 1 1 5.321 4.838Z" }, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3))
}
export default { render: render }